import { render, staticRenderFns } from "./warehousedeptstock.vue?vue&type=template&id=082fc9e5&"
import script from "./warehousedeptstock.vue?vue&type=script&lang=js&"
export * from "./warehousedeptstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports